import { createContext } from "react";

const IssuerContext = createContext({} as any);

export default IssuerContext;